export const HOME_SCREEN_WIDTH = 800;
export const NAVIGATION_BAR_HEIGHT = 72;
